export const AccessEditPageSkeleton = () => {
  return (
    <div className="p-8 w-full">
      <div className="flex justify-between items-center">
        <div className="animate-pulse rounded-md bg-skeleton h-8 w-44" />
        <div className="flex gap-6 items-center">
          <div className="animate-pulse rounded-md bg-skeleton h-10 w-32" />
          <div className="animate-pulse rounded-md bg-skeleton h-10 w-32" />
        </div>
      </div>
      <div className="animate-pulse rounded-md bg-skeleton h-96 w-full mt-9" />
    </div>
  )
}
